import "toastr/build/toastr.min.css";
import { toast } from "react-toastify";
import { REPORT } from "../config/apiEndPoint";
import { POST } from "config/api.config";

/** POST `Report/client-status/filter` */
export const submitClientStatusReportFilterData = async (data = {}) => {
    try {
        const response = await POST(REPORT.CLIENT_STATUS_FILTER, data);
        return response;
    } catch (error) {
        toast.error(error?.message);
    }
};
